export default __webpack_public_path__ + "static/media/Prancheta 5.80afe943.svg";